const LAND_TYPES = new Set([
  'gut_number', 'survey_number', 'milkat_number',
  'plot_number', 'cts_number', 'bhumapan_number', 'block_number',
]);
const FLAT_TYPES = new Set(['flat_number', 'shop_number', 'sadanika_number']);

export function matchesPropertyType(record, propertyType) {
  const nums = record.property_numbers || [];
  if (nums.length === 0) return true;
  if (propertyType === 'land') return nums.some((n) => LAND_TYPES.has(n.type));
  return nums.some((n) => FLAT_TYPES.has(n.type));
}

export function dedupeRecords(raw) {
  const seen = new Set();
  const unique = [];
  for (const rec of raw || []) {
    if (!rec) continue;
    const key = rec.key;
    if (!key) {
      unique.push(rec);
      continue;
    }
    if (seen.has(key)) continue;
    seen.add(key);
    unique.push(rec);
  }
  return unique;
}

export function formatPartialDate(dateStr) {
  if (!dateStr) return null;
  const match = dateStr.match(/(\d{1,2})[\/\-](\d{1,2})/);
  if (match) return `${match[1].padStart(2, '0')}/${match[2].padStart(2, '0')}`;
  return dateStr;
}

export function buildSearchUrl(apiBase, { dParam, tParam, vParam, district, taluka, village, query }) {
  if (dParam && tParam && vParam) {
    return `${apiBase}/search?d=${encodeURIComponent(dParam)}&t=${encodeURIComponent(tParam)}&v=${encodeURIComponent(vParam)}&query=${encodeURIComponent(query)}`;
  }
  return `${apiBase}/search?district=${encodeURIComponent(district)}&taluka=${encodeURIComponent(taluka)}&village=${encodeURIComponent(village)}&query=${encodeURIComponent(query)}`;
}
